import React from 'react';
import { Locales } from 'src/lib/constants';
import { toKebabCase } from 'src/lib/utils';
import { dangerous_getStaticData } from 'src/lib/getStaticData';

// lazy load template so that we have access to the window object
import DocsTemplate from 'src/templates/DocsTemplate/DocsTemplate';

//components
import { Link } from 'src/components/Inputs';
import Spacer from 'src/components-v2/Layout/Spacer/Spacer';

// meta data
const metaData = {
  layout: 'docs',
  'meta-title': 'Developer Policy',
  'subnav-filters-hidden': 'true',
  'hide-search': 'true',
};
const DeveloperPolicy = ({ locale = Locales.EN_US }) => {
  const { intro, tableOfContentsTitle, sections } = dangerous_getStaticData({
    locale,
    filePath: 'developer-policy',
  });

  return (
    <DocsTemplate {...metaData} locale={locale}>
      <div className='bg-docs'>
        <div id='docsWrapper' className='grid-container'>
          <div className='grid-x'>
            <article id='docsArticle' className='cell small-12 article-docs'>
              <div className='article-docs-content'>
                <div id='policy-intro'>
                  <Spacer height={100} />
                  <h2 id='developer-policy'>{intro.title}</h2>
                  <p
                    dangerouslySetInnerHTML={{ __html: intro.effectiveDate }}
                  />
                  {Array.isArray(intro.description)
                    ? intro.description?.map((paragraph) => {
                        return (
                          <p
                            dangerouslySetInnerHTML={{ __html: paragraph }}
                          ></p>
                        );
                      })
                    : intro?.description}
                </div>
                <div id='policy-table-of-contents'>
                  <p>
                    <em>{tableOfContentsTitle}</em>
                  </p>
                  {sections.map((section, i) => {
                    return (
                      <p key={`${section.title}-${i}`}>
                        <Link
                          href={`#${toKebabCase(section.title) || section?.id}`}
                        >
                          <a data-smooth-scroll data-offset='-10'>
                            {section.title}
                          </a>
                        </Link>
                      </p>
                    );
                  })}
                </div>
                <div id='policy-sections'>
                  {sections.map((section, i) => {
                    return (
                      <div
                        className='policy-section'
                        key={`${section.title}-${i}`}
                      >
                        <h5 id={toKebabCase(section.title) || section?.id}>
                          {section.title}
                        </h5>
                        {Array.isArray(section?.description)
                          ? section?.description?.map((desc) => {
                              if (Array.isArray(desc)) {
                                return (
                                  <ul>
                                    {desc.map((listItem) => {
                                      return (
                                        <li
                                          dangerouslySetInnerHTML={{
                                            __html: listItem,
                                          }}
                                        />
                                      );
                                    })}
                                  </ul>
                                );
                              } else {
                                return (
                                  <p
                                    dangerouslySetInnerHTML={{ __html: desc }}
                                  />
                                );
                              }
                            })
                          : section?.description}
                      </div>
                    );
                  })}
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </DocsTemplate>
  );
};

export default DeveloperPolicy;
